export default __webpack_public_path__ + "static/media/tractor.abad0c11.png";